import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hierarchicalGroup',
  standalone: false,
})
export class HierarchicalGroupPipe implements PipeTransform {
  public transform(
    groupPath: string,
    showLastSegmentOnly = true,
    showIndentation = true,
    indentationChar = '›' // └
  ): string {
    if (!groupPath) return '';

    if (groupPath === '/') {
      return '/';
    }

    const normalizedPath = groupPath.startsWith('/')
      ? groupPath
      : `/${groupPath.replaceAll('.', '/')}`;

    const segments = normalizedPath.split('/').filter(Boolean);

    if (segments.length === 0) {
      return '/';
    }

    const lastSegment = segments[segments.length - 1];

    const level = segments.length;

    if (!showLastSegmentOnly && !showIndentation) {
      return normalizedPath;
    }

    if (showLastSegmentOnly && !showIndentation) {
      return lastSegment;
    }

    const indentation =
      level > 1 && showIndentation
        ? `${indentationChar.repeat(level - 1)} `
        : '';

    return indentation + (showLastSegmentOnly ? lastSegment : normalizedPath);
  }
}
